import { joinDateAndTime } from "helpers";
import moment from "moment";

import { OfferFormValues } from "../features";

export const requestBodyData = (
  formData: OfferFormValues,
  id: string | undefined
) => {
  const {
    image,
    title,
    fromPostingDate,
    fromPostingTime,
    toPostingDate,
    toPostingTime,
    productVariants,
    productSet,
    allowDisplayInFullScreenMode
  } = formData;

  const from = joinDateAndTime(fromPostingDate, fromPostingTime);
  const to = joinDateAndTime(toPostingDate, toPostingTime);

  const currentDate = moment();
  const isStatusInactive =
    moment(currentDate).isBefore(from, undefined) ||
    moment(currentDate).isAfter(to, undefined);

  const productVariantIds = productVariants.map(
    ({ id: variantId }) => variantId
  );

  const body = {
    imageId: image?.id ?? "",
    title,
    from,
    to,
    ...(id && isStatusInactive ? { status: "Inactive" } : null),
    productVariantIds,
    productSetId: productSet?.id ?? null,
    ...(allowDisplayInFullScreenMode !== undefined
      ? { allowDisplayInFullScreenMode }
      : null)
  };

  return body;
};
